import { MaintenanceWindowsAppWebComponent } from './component/MaintenanceWindowsAppWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOWS_APP } from '../../webcomponents.constants';

export { MaintenanceWindowsAppWebComponent };

window.customElements.define(WEB_COMPONENT_MAINTENANCE_WINDOWS_APP, MaintenanceWindowsAppWebComponent);
